export enum ApplicationSettingEnum {
    Email,
    Password,
    Host,
    Port,
    SSL,
    ReceiveEmailHost,
    ReceiveEmailPort,
    MeetingRoomScheduleingApplicationUser,
    MeetingRoomScheduleingApplicationPassword,
    HomeOffline
}
